import { render, staticRenderFns } from "./AccountRecord.vue?vue&type=template&id=e2ffd3aa&scoped=true&"
import script from "./AccountRecord.vue?vue&type=script&lang=ts&"
export * from "./AccountRecord.vue?vue&type=script&lang=ts&"
import style0 from "./AccountRecord.vue?vue&type=style&index=0&id=e2ffd3aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ffd3aa",
  null
  
)

export default component.exports